<template>
    <div class="container-fluid authorizerCompanyWrapper">
        <div class="row">
            <div class="col-12 col-md-6 mb-4">
                <authorizer-group-info
                    :group="group"
                    :parent-group="parentGroup">
                </authorizer-group-info>
            </div>
        </div>

        <b-card no-body>
            <b-tabs card>
                <b-tab :title="`${$locale.patient}一覧`">
                    <b-container fluid>
                        <authorizer-group-users
                            :timezone="timezone"
                            :parent-group="parentGroup"
                            :group="group">
                        </authorizer-group-users>
                    </b-container>
                </b-tab>
                <b-tab
                    v-if="group.is_tab_consultation"
                    :title="`${$locale.consultation_host}一覧`">
                    <b-container fluid>
                        <authorizer-group-consultations
                            :timezone="timezone"
                            :parent-group="parentGroup"
                            :group="group"
                            :medical-courses="medicalCourses">
                        </authorizer-group-consultations>
                    </b-container>
                </b-tab>
                <b-tab
                    v-if="group.is_health_survey"
                    title="メンタルチェック回答一覧">
                    <b-container fluid>
                        <authorizer-group-health-surveys
                            :timezone="timezone"
                            :parent-group="parentGroup"
                            :group="group">
                        </authorizer-group-health-surveys>
                    </b-container>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'

    export default {
        props: {
            timezone: {
                type: String,
                required: true,
            },
            group: {
                type: Object,
                required: true,
            },
            medicalCourses: {
                type: Array,
                required: true,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
            }
        },

        computed: {
            parentGroup: function () {
                return this.group.parent_groups.find((parentGroup) => {
                    return parentGroup.group_type === constants.groupType.organization
                })
            },
        },
    }
</script>

<style lang="scss">
.authorizerCompanyWrapper {
    .tab-content > .tab-pane {
        overflow: hidden;
    }
}
</style>
